import { buttonSx } from '../../styles/Global.style';

export const signUpHoldingContainerSx = (height) => ({
  maxWidth: '400px',
  margin: '0 auto',
  padding: '16px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  height: height,
});

export const logoContainerSx = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
};

export const xLogoSx = { margin: '0 12px' };

export const countdownSx = (theme, font) => ({
  color: theme.palette.tertiary.main,
  fontSize: '32px',
  fontFamily: font,
  fontWeight: 700,
  textAlign: 'center',
});

export const titleSx = {
  fontSize: '32px !important',
  marginBottom: '12px',
  width: '80%',
};

export const reloadButtonSx = (theme) => ({
  backgroundColor: theme.palette.tertiary.main,
  ...buttonSx(theme),
});

export const buttonContainerSx = {
  paddingBottom: 'calc(env(safe-area-inset-bottom, 0) + 8px)',
};
